<template>
  <div>
    <div id="shopping-cart" v-if="drugs">
      <button type="button" class="btn btn-default" @click="shopCartModal = true">
        <span class="glyphicon glyphicon-shopping-cart"></span> Drug Allocation
      </button>
    </div>

    <modal v-if="shopCartModal" @close="onCloseModal">
    <div slot="header">
      <h3>Allocate Drugs</h3>
      <input type="text" v-model="filter" class="form-control" placeholder="Search...">
    </div>
    <div slot="body">
      <div v-for="(drug_group, groupIndex) in drugs" :key="drug_group.name">

        <h3 @click="toggleGroup(groupIndex)">
          <u>{{ drug_group.name }}</u>
        </h3>

          <div class="drug_group clearfix" :class="{ show: shouldShowGroup(groupIndex),  hide: !shouldShowGroup(groupIndex)  }" :style="{ width: 400 + widthForRow(farms) + 'px' }">
            <div class="farm-fields">
              <h4>
                <br>
                  Quantity Purchased Last Season
              </h4>
            </div>

            <div v-for="farm in farms" class="farm-fields" :key="`farmtitle_${farm.id}`">
              <h4>
                {{ farm.farm_label }}
                <br>
                  New Season Allocations
              </h4>
              <br />
              <div class="alert alert-warning" v-if="drug_group.pk == 16 && getFieldValue(prefixedField('wants_scour_vaccine', farm.id), 'PreventiveHealthAndVacination') != 'Yes'">
                <radio-input
                  label="Scour vaccine?"
                  :field-name="`farm_${farm.id}-wants_scour_vaccine`"
                  subtext="Please select 'Yes' if you want to add or adjust scour vaccine allocations. An order email will be sent to retail if 'Yes' is selected. select Scour vaccine from Drug Allocations below"
                  :commentFieldName="`farm_${farm.id}-wants_scour_vaccine_comments`"
                  :addComment="true"
                  :addEmailNotification="true"
                  :choices="[
                    { value: 'Yes', display: 'Yes' },
                    { value: 'No', display: 'No' },
                  ]"
                  :disabled="isReadOnly"
                >
                </radio-input>
              </div>
            </div>
          </div>


          <div class="alert alert-warning" v-if="filteredDrugs(drug_group.drugs).length <= 0">
            No Results Found
          </div>
          <div v-for="drug in filteredDrugs(drug_group.drugs)" :key="drug.pk">


            <div class="clearfix drug_group"  :class="{ show: shouldShowGroup(groupIndex),  hide: !shouldShowGroup(groupIndex)  }" :style="{ width: 400 + widthForRow(farms) + 'px' }">

              <div v-if="drug.inactive == false || rvmModel.last_year_usage[drug.pk] > 0">  <!-- show disabled products only if they got last year data. -->
                <div class="farm-fields">
                  <div class="form-group">
                    <label> {{ drug.name }} </label>
                    <input type="number" v-model="rvmModel.last_year_usage[drug.pk]" class="form-control" disabled>
                  </div>
                </div>

                <div v-for="farm in farms" class="farm-fields" :key="`drug-${drug.pk}-${farm.id}`">

                  <template v-if="drug_group.pk == 16 && getFieldValue(prefixedField('wants_scour_vaccine', farm.id), 'PreventiveHealthAndVacination') != 'Yes'">
                  </template>
                  <template v-else>
                    <div v-if="drug_group.pk == '15' && newAllocations[farm.id][drug.pk].is_pre_allocation" class="form-group" >
                      <label> {{ drug.name }} </label>
                      <div class="row">
                        <div class="col-md-6">
                          <input type="number"
                            v-model="newAllocations[farm.id][drug.pk].par_qty"
                            class="form-control"
                            :disabled="drug.inactive || !canSyncAllocations || isReadOnly || drug.disallow_allocations"/>
                          <span class="text-danger"> Expires {{ new Date(newAllocations[farm.id][drug.pk].par_end_date).toLocaleDateString() }} </span>
                        </div>

                        <div class="col-md-6">
                          <input type="number"
                            v-model="newFutureAllocations[farm.id][drug.pk].par_qty"
                            class="form-control"
                            :disabled="drug.inactive || !canSyncAllocations || isReadOnly || drug.disallow_allocations"/>
                          <span class="text-danger"> {{ futureAllocationDates(new Date(newAllocations[farm.id][drug.pk].par_end_date)) }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else class="form-group">
                      <label> {{ drug.name }} </label>
                      <input type="number"
                        v-model="newAllocations[farm.id][drug.pk].par_qty"
                        class="form-control"
                        :disabled="drug.inactive || !canSyncAllocations || isReadOnly || drug.disallow_allocations"
                        :placeholder="[ drug.inactive ? 'Disabled' : '' ]"/>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
      </div>
    </div>
    </modal>
  </div>
</template>

<script>
import Modal from '../Modal'
import { mapGetters, mapMutations } from 'vuex'
import RadioInput from '@/components/inputs/RadioInput'
import { prefixedField } from '@/_helpers/utils'

export default {
  name: 'DrugAllocationCart',
  props: [
    'farms',
    'drugs',
    'isReadOnly',
  ],
  components: {
    Modal,
    RadioInput,
  },
  data() {
    return {
      shopCartModal: false,
      filter: '',
      newAllocations: {},
      newFutureAllocations: {},
      groupVisibility: {},
      dataLoaded: false,
    }
  },
  mounted: function() {
    // if a vet jumps between steps that handle same drug allocation groups, we
    // encounter an issue where we dont grab latest idb data because its still
    // being async stored. by waiting until the modal is mounted to load data we
    // wait enough time for that not to happen. we should really handle
    // allocations in memory all the time and have them async stored into idb as
    // soon as any change is done.
    if (this.dataLoaded == true)  return
    for (const farm of this.farms) {

      this.newAllocations[farm.id] = {}
      this.newFutureAllocations[farm.id] = {}

      for (const drugGroup of this.drugs) {
        for (const drug of drugGroup.drugs) {
          // Initialize newAllocations model
          this.newAllocations[farm.id][drug.pk] = {
            par_qty: 0,
            drug_allocation_product: drug.pk,
            par_end_date: null,
            is_pre_allocation: null,
            is_future_allocation: false,
          }

          // Initialize newFutureAllocations for Critically IA GROUP
          if (drugGroup.pk == '15') {
            this.newFutureAllocations[farm.id][drug.pk] = {
              par_qty: 0,
              drug_allocation_product: drug.pk,
              is_pre_allocation: null,
              is_future_allocation: true,
              par_end_date: null,
            }
          }
        }
      }

      for (const allocation of this.rvmModel.drugs_allocated[farm.id]) {
        let data = {
          par_qty: allocation.par_qty,
          drug_allocation_product: allocation.drug_allocation_product,
          is_pre_allocation: allocation.is_pre_allocation,
          is_future_allocation: allocation.is_future_allocation,
          par_end_date: allocation.par_end_date,
        }
        if (allocation.is_future_allocation) {
          this.newFutureAllocations[farm.id][allocation.drug_allocation_product] = data
        } else {
          this.newAllocations[farm.id][allocation.drug_allocation_product] = data
        }
      }
    }
    this.dataLoaded = true
  },
  methods: {
    ...mapMutations('currentConsult', ['updateOrCreateAllocation']),
    widthForRow(farms) {
      return farms.length * 400;
    },
    toggleGroup: function (groupIndex) {
      this.$set(this.groupVisibility, groupIndex, !this.groupVisibility[groupIndex])
    },
    shouldShowGroup: function (groupIndex) {
      return this.searching || Boolean(this.groupVisibility[groupIndex]);
    },
    filteredDrugs: function(drugs) {
      if (this.filter) {
        let filteredDrugs = [];
        for (const drug of drugs)
        {
          if (drug.name.toLowerCase().includes(this.filter.toLowerCase().trim()))
          {
            filteredDrugs.push(drug)
          }
        }
        return filteredDrugs;
      } else {
        return drugs
      }
    },
    onCloseModal: function() {
      this.shopCartModal = false
      this.$emit('drug-allocations-cart-closed')
      for (const farm of this.farms) {
        Object.entries(this.newAllocations[farm.id]).forEach(([key, data]) => {
          if (!data.par_qty) {
            data.par_qty = 0
          }

          let allocExists = this.rvmModel.drugs_allocated[farm.id].find(
            alloc => (alloc.drug_allocation_product == key && alloc.is_future_allocation == false)
          )

          if (data.par_qty > 0 || allocExists) {
            this.updateOrCreateAllocation([farm.id, data, false])
          }
        })

        Object.entries(this.newFutureAllocations[farm.id]).forEach(([key, data]) => {
          if (!data.par_qty) {
            data.par_qty = 0
          }

          let allocExists = this.rvmModel.drugs_allocated[farm.id].find(
            alloc => (alloc.drug_allocation_product == key && alloc.is_future_allocation == true)
          )

          if (data.par_qty > 0 || allocExists) {
            this.updateOrCreateAllocation([farm.id, data, true])
          }
        })
      }
    },
    futureAllocationDates: function(parEndDate) {
      let futureAllocationStartDate

      let today = new Date()

      if (parEndDate > today) {
        futureAllocationStartDate = this.$moment(parEndDate).add('1', 'days')
      } else {
        futureAllocationStartDate = this.$moment(today)
      }
      return futureAllocationStartDate.format("DD-MM-YYYY") + '  -  ' + futureAllocationStartDate.add('4', 'months').format("DD-MM-YYYY")
    },
    prefixedField: prefixedField,
  },
  computed: {
    ...mapGetters('currentConsult', [
      'getFieldValue',
    ]),
    canSyncAllocations () 
    {
      return !this.rvmModel.has_synced_allocations;
    },
    rvmModel () 
    {
      return this.$store.state.currentConsult.models['DrugAllocations']
    },
    searching: function () 
    {
      return Boolean(this.filter);
    }
  }
};
</script>

<style scoped>
#shopping-cart {
  position: fixed;
  bottom: 10px;
  right: 10px;
}
</style>
